export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12 md:py-16">
          <div>
            <h3 className="text-lg font-heading text-background-50 mb-4">羞羞歪歪漫画</h3>
            <p className="text-sm leading-relaxed text-background-400">
              羞羞歪歪漫画在线观看入口官网，提供在线看、入口与观看地址，免费全集无删减下拉式阅读。汇聚海量热门漫画资源，每日更新，畅享极致阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: '读者热评', href: '#comments' },
                { label: '专题精选', href: '#carousel' },
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">热门分类</h4>
            <nav className="flex flex-col gap-2">
              {['热血漫画', '恋爱漫画', '搞笑漫画', '悬疑漫画', '奇幻漫画'].map((cat) => (
                <span key={cat} className="text-sm text-background-400 cursor-pointer hover:text-primary-400 transition-colors duration-200">
                  {cat}
                </span>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">期待与更多优质平台携手合作</p>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 羞羞歪歪漫画在线观看入口官网. All Rights Reserved.
          </p>
          <p className="text-xs text-background-600">
            本站内容仅供学习交流，请于下载后24小时内删除
          </p>
        </div>
      </div>
    </footer>
  );
}